import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

export default function ImageLightbox({ image, onClose }: { image: string | null; onClose: () => void }) {
  const closeButton = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!image) return;
    const previousFocus = document.activeElement as HTMLElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeButton.current?.focus();
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
      if (event.key === 'Tab') { event.preventDefault(); closeButton.current?.focus(); }
    };
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = previousOverflow;
      previousFocus?.focus();
    };
  }, [image]);
  if (!image) return null;
  return createPortal(
    <div role="dialog" aria-modal="true" aria-label="Xem ảnh thi công" className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4" onClick={onClose}>
      <button ref={closeButton} type="button" aria-label="Đóng ảnh" onClick={onClose} className="absolute top-4 right-4 text-white bg-white/15 rounded-full p-3 focus-visible:outline-2 focus-visible:outline-white"><X size={24} /></button>
      <img src={image} alt="Ảnh tư liệu thi công" className="max-w-full max-h-[90dvh] object-contain rounded-lg" onClick={event => event.stopPropagation()} />
    </div>, document.body,
  );
}
